export default __webpack_public_path__ + "385fd55ff3a27f1e3aef923950124326.png";